module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Bold.44915dd2.ttf";